import { BorrowerNaturalPersonDto, LoanBaseDto } from 'api/borrower';
import { FC, useMemo } from 'react';
import { getCivilityIcon } from 'shared/utils/civility';

interface LoanInfoCardProps {
  insured: BorrowerNaturalPersonDto;
  insuredCivility: string;
  loan: LoanBaseDto;
  loanTypeLabel: string;
}

const ICON_CLASS = 'w-8 text-primary';

export const LoanInfoCard: FC<LoanInfoCardProps> = ({
  insured,
  insuredCivility,
  loan,
  loanTypeLabel
}) => {
  const genderIcon = useMemo(() => {
    const Icon = getCivilityIcon(insuredCivility);
    return <Icon className={ICON_CLASS} />;
  }, [insuredCivility]);

  const formattedFirstName = useMemo(() => {
    return insured.firstName.charAt(0).toUpperCase() + insured.firstName.slice(1).toLowerCase();
  }, [insured.firstName]);

  return (
    <div className="p-4 flex border bg-white rounded-xl">
      <div className="w-64 flex items-center gap-4">
        <div>{genderIcon}</div>
        <div>
          <p className="font-bold">{insured.lastName.toUpperCase()}</p>
          <p>{formattedFirstName}</p>
        </div>
      </div>
      <div className="grow flex flex-col pl-4 gap-2">
        <p className="font-bold">
          {`Prêt ${loanTypeLabel} de ${loan.loanAmount} €`}
        </p>
        <div>
          <span className="text-primary font-bold bg-primary/20 rounded-full px-3 py-1">
            {`${loan.totalDuration} mois`}
          </span>
        </div>
      </div>
    </div>
  );
};
